import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";
import type React from "react";
import { useMemo } from "react";
import Autocomplete from "@mui/material/Autocomplete";

import type { AttributeInputProps } from "./types.ts";
import "./attribute-filter.css"

export const RokUvedeniDoProvozuDo: React.FC<AttributeInputProps> = (
  {
    overviewForm,
    attributesList,
    allAds,
  }) => {

  const years: number[] = useMemo(() => {
    const unique: Record<string, number> = {};
    for (const item of allAds) {
      if (item.attributes.model) {
        const rokVyroby = item.attributes.rokUvedeniDoProvozu;
        if (rokVyroby) {
          const year: number = (new Date(rokVyroby)).getFullYear();
          unique[year] = year;
        }
      }
    }
    const result = Object.values(unique).toSorted((a: number, b: number) => a - b);
    return result;
  }, [ allAds ]);

  // is enabled?
  const attribute = useMemo(() => (
    // biome-ignore lint/nursery/noSecrets: <explanation>
    attributesList.find((attr) => attr.name === "RokUvedeniDoProvozu")
  ), [ attributesList ]);
  if (!attribute) {
    return null;
  }

  return (
    <overviewForm.Field name="DetailCategoryFilter.RokUvedeniDoProvozuDo">
      {(fieldApi) => {
        const value = fieldApi.state.value;

        return (
          <div
            className={"SZAutoComplete"} // items are inserted after Autocomplete
          >
            <Autocomplete
              value={value} // ?? null}
              size="small"
              disablePortal={true}
              fullWidth={true}
              options={years}
              freeSolo={true}
              onKeyUp={(e) => {
                // We want to allow any input, even when years are not available
                // if(years.length === 0) {
                fieldApi.setValue(e.target.value);
                // }
              }}
              onChange={(_e, value) => {
                // setFilterAtom(value ?? ""); // do not reload page
                fieldApi.setValue(value ?? "");
              }}
              renderInput={(params) => (
                <TextField {...params} color="secondary" variant="filled" label={"Rok uvedení do provozu (do)"}/>
              )}
              clearIcon={
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => {
                    fieldApi.setValue("");
                  }}
                >
                  <Close/>
                </IconButton>
              }
            />
          </div>
        );
      }}
    </overviewForm.Field>
  );
};
